import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    objectsInCart: {},
    clipsInCart: [],
    mediaCount: { video: 0, pictures: 0, other: 0},
    sort: { orderBy: 'rechte_produktionsdatum', order: 'DESC'},

};
const changeSortOrder = (state, action) => {
    if(action.payload.target === 'cart') {
            const allClips = action.payload.allClips;
            const orderBy = action.payload.sortOrder.split('|')[0];
            const order = action.payload.sortOrder.split('|')[1];
            let clips = null;
            if(order === 'ASC') {
                clips = state.clipsInCart.slice().sort((id1, id2) => allClips[id2].metadata[orderBy] > allClips[id1].metadata[orderBy] ? 1 : -1);
            } else {
                clips = state.clipsInCart.slice().sort((id1, id2) => allClips[id1].metadata[orderBy] > allClips[id2].metadata[orderBy] ? -1 : 1);
            }
            
            return updateObject(state, {clipsInCart: clips ,sort: {orderBy:orderBy, order: order}});
        
    }
    return state;
}

const addObjToCart = (state, action) => {
    const objs = { ...state.objectsInCart }
    
    action.objs.forEach(obj => {
        objs[obj.id] = obj;
    });
    
    return updateObject(state, { objectsInCart: objs });
}

const removeObjFromCart = (state, action) => {
    const objs = { ...state.objectsInCart }
    
    action.objs.forEach(obj => {
        if(obj.id in objs) {
            delete objs[obj.id];
        }
    });
    
    return updateObject(state, { objectsInCart: objs });
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_OBJ_TO_CART: 
            return addObjToCart(state, action);
        case actionTypes.REMOVE_OBJ_FROM_CART: 
            return removeObjFromCart(state, action);
        case actionTypes.REMOVE_ALL_OBJ_FROM_CART: 
            return updateObject(state, { objectsInCart: {} });
        case actionTypes.ADD_SELECTED_TO_CART: 
            let cart = [...state.clipsInCart];
            action.payload.clips.forEach(element => {
                if(cart.indexOf(element) === -1) {
                    cart.push(element);
                }
            });
            return updateObject(state, {clipsInCart: cart});
        case actionTypes.EMPTY_CART: 
			return updateObject(state, {clipsInCart: []});
        case actionTypes.ADD_CLIP_TO_CART: 
            cart = [...state.clipsInCart];
            if(cart.indexOf(action.payload.id) === -1) {
                cart.push(action.payload.id);
            }
            return updateObject(state, {clipsInCart: cart});
        case actionTypes.REMOVE_CLIP_FROM_CART:
            cart = state.clipsInCart.filter( c => {
                return c !== action.payload.id
            });
            return updateObject(state, {clipsInCart: cart}); 
        case actionTypes.SET_SORTORDER: 
			return changeSortOrder(state, action);    
        default: 
            return state;
    }
} 

export default reducer;
